import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from as fromPromise, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import {
    CustomTemplate,
    CustomTemplateBody,
    CustomTemplateCreate,
    CustomTemplateUpdate
} from './model';
import {
    customTemplateCreateDecoder,
    customTemplateDecoder,
    customTemplatesDecoder,
    customTemplateUpdateDecoder
} from './decoder';

@Injectable()
export class CustomTemplatesService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    getCustomTemplates(type: string): Observable<CustomTemplate[]> {
        return this.http
            .get<CustomTemplate[]>(`${this.environment.api}me/customTemplates?type=${type}`)
            .pipe(
                concatMap(p => {
                    return fromPromise(customTemplatesDecoder.decodeToPromise(p));
                })
            );
    }

    getCustomTemplate(id: number): Observable<CustomTemplate> {
        return this.http
            .get<CustomTemplate>(`${this.environment.api}me/customTemplates/${id}`)
            .pipe(
                concatMap(p => {
                    return fromPromise(customTemplateDecoder.decodeToPromise(p));
                })
            );
    }

    createCustomTemplate(template: CustomTemplateBody): Observable<CustomTemplateCreate> {
        return this.http
            .post<CustomTemplate>(`${this.environment.api}me/customTemplates`, template)
            .pipe(
                concatMap(p => {
                    return fromPromise(customTemplateCreateDecoder.decodeToPromise(p));
                })
            );
    }

    updateCustomTemplate(template: CustomTemplateBody): Observable<CustomTemplateUpdate> {
        return this.http
            .put<CustomTemplate>(`${this.environment.api}me/customTemplates/${template.id}`, {
                type: template.type,
                isPrimary: template.isPrimary,
                body: template.body,
                subject: template.subject,
                name: template.name
            })
            .pipe(
                concatMap(p => {
                    return fromPromise(customTemplateUpdateDecoder.decodeToPromise(p));
                })
            );
    }

    deleteCustomTemplate(id: number): Observable<any> {
        return this.http.delete(`${this.environment.api}me/customTemplates/${id}`);
    }
}
